import GetRequestFormByIdRequestModelBase from '../_generated/modelBases/get-request-form-by-id-request-model-base';

export default class GetRequestFormByIdRequestModel extends GetRequestFormByIdRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
